"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireWildcard(require("react"));
var _groupEmail = _interopRequireDefault(require("../../core/group-email"));
var _occasion = _interopRequireDefault(require("occasion"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
// *******************************************************************************
// Flag Filters
// *******************************************************************************

const flags = [{
  id: 'isPublished',
  description: 'Published',
  canClear: true,
  trueLabel: 'Is Published',
  falseLabel: 'Not Published',
  enabled: competitions => competitions.some(c => c.isPublished) && competitions.some(c => !c.isPublished),
  check: (state, comp) => state.isPublished === null || comp.isPublished === state.isPublished
}, {
  id: 'isOpen',
  description: 'Currently Open for Entries',
  canClear: true,
  trueLabel: 'Is Open',
  falseLabel: 'Not Open',
  enabled: competitions => {
    const today = new Date().toISOString().split('T')[0];
    return competitions.some(c => c.openForOnlineEntryDate <= today && c.allClosedForEntryDate > today) && competitions.some(c => c.openForOnlineEntryDate > today || c.allClosedForEntryDate <= today);
  },
  check: (state, comp) => {
    const today = new Date().toISOString().split('T')[0];
    return state.isOpen === null || (comp.openForOnlineEntryDate <= today && comp.allClosedForEntryDate > today) === state.isOpen;
  }
}, {
  id: 'isCancelled',
  description: 'Cancelled',
  canClear: true,
  trueLabel: 'Cancelled',
  falseLabel: 'Not Cancelled',
  enabled: competitions => competitions.some(c => c.isCancelled) && competitions.some(c => !c.isCancelled),
  check: (state, comp) => state.isCancelled === null || comp.isCancelled === state.isCancelled
}];

// *******************************************************************************
// Filter Sets
// *******************************************************************************

const filterSets = props => [{
  id: 'includeDivisions',
  description: 'Competition Divisions',
  options: (state, filteredCompetitions) => props.tiers.filter(t => state.includeDivisions.includes(t.id) || filteredCompetitions.some(comp => comp.competitionDivisions.some(cdiv => cdiv.tierRef === t.id))),
  check: (state, comp) => !state.includeDivisions.length || comp.competitionDivisions.some(cdiv => state.includeDivisions.includes(cdiv.tierRef))
}, {
  id: 'includeMonths',
  description: 'Start Month',
  options: (state, filteredCompetitions) => [{
    id: 1,
    description: 'January'
  }, {
    id: 2,
    description: 'February'
  }, {
    id: 3,
    description: 'March'
  }, {
    id: 4,
    description: 'April'
  }, {
    id: 5,
    description: 'May'
  }, {
    id: 6,
    description: 'June'
  }, {
    id: 7,
    description: 'July'
  }, {
    id: 8,
    description: 'August'
  }, {
    id: 9,
    description: 'September'
  }, {
    id: 10,
    description: 'October'
  }, {
    id: 11,
    description: 'November'
  }, {
    id: 12,
    description: 'December'
  }].filter(month => state.includeMonths.includes(month.id) || filteredCompetitions.some(comp => +(0, _occasion.default)(comp.startDate, 'M') === month.id)),
  check: (state, comp) => !state.includeMonths.length || state.includeMonths.includes(+(0, _occasion.default)(comp.startDate, 'M'))
}];

// *******************************************************************************
// Email Fields
// *******************************************************************************
const emailFields = [{
  id: 'organiserEmail',
  description: 'Organisers',
  default: true,
  emailAddresses: competition => [competition.organiserEmail]
}, {
  id: 'administratorEmail',
  description: 'All Administrators',
  default: false,
  emailAddresses: competition => competition.competitionAdministrators.map(admin => admin.administratorEmail)
}];

// *******************************************************************************
// Main Component
// *******************************************************************************

class EmailFilter extends _react.Component {
  render() {
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_groupEmail.default, {
      flags: flags,
      filterSets: filterSets(this.props),
      emailFields: emailFields,
      dataRecords: this.props.competitions,
      sender: this.props.userEmail,
      emailSubject: "Canoe Slalom Online Entries",
      onSend: this._onCloseModal
    })));
  }
}
// *******************************************************************************
// Data and actions
// *******************************************************************************
var _ref = {
  id: true,
  competitionName: true,
  competitionSlug: true,
  isPublished: true,
  openForOnlineEntryDate: true,
  allClosedForEntryDate: true,
  displayStartList: true,
  isCancelled: true,
  organiserEmail: true,
  startDate: true,
  competitionDivisions: {
    tierRef: true
  },
  competitionAdministrators: {
    id: true,
    administratorEmail: true
  }
};
var _ref2 = {
  "tierRef as id": true,
  "tierDescription as description": true
};
var _default = exports.default = (0, _reactBicycle.connect)(EmailFilter, props => ({
  userEmail: true,
  ["competitions(yearID:" + JSON.stringify(+props.yearID) + ")"]: _ref,
  ["defaultTiersByYear(yearID:" + JSON.stringify(+props.yearID) + ") as tiers"]: _ref2
}));